import { Box, Button, Divider, IconButton, Modal, Typography } from "@mui/material";
import { SendHorizonal, X } from "lucide-react";

import "./SummaryModal.scss";

interface SelectedOption {
	id: number;
	name: string;
}

export default function SummaryModal({
	open,
	onClose,
	onSave,
	selectedHospitals,
	selectedAuthors,
	title,
	description,
	selectedCategory,
	selectedAreas,
	resources,
}: {
	open: boolean;
	onClose: () => void;
	onSave: () => Promise<void>;
	selectedHospitals: SelectedOption[];
	selectedAuthors: SelectedOption[];
	title: string;
	description: string;
	selectedCategory: SelectedOption | undefined;
	selectedAreas: SelectedOption[];
	resources: string;
}) {
	const summaryText = (label: string, information: string) => {
		return (
			<>
				<Box className="form__summary__body__section">
					<Typography>{label}</Typography>
					<Typography>{information}</Typography>
				</Box>
				<Divider className="form__summary__body__divider" />
			</>
		);
	};

	return (
		<Modal
			open={open}
			onClose={onClose}
		>
			<Box className="form__summary">
				<Box className="form__summary__header">
					<Typography className="form__summary__header__title">
						Todo listo para enviar tu idea.
					</Typography>
					<Typography className="form__summary__header__subtitle">
						Por favor, confirma que la información a enviar sea correcta.
					</Typography>
					<IconButton>
						<X onClick={onClose} />
					</IconButton>
				</Box>

				<Box className="form__summary__body">
					{summaryText(
						"Unidad(es)",
						selectedHospitals.length > 0
							? selectedHospitals
									.map((hospital: SelectedOption) => hospital.name)
									.join(", ")
							: "No seleccionadas",
					)}
					{summaryText(
						"Autor(es)",
						selectedAuthors.length > 0
							? selectedAuthors
									.map((author: SelectedOption) => author.name)
									.join(", ")
							: "No seleccionados",
					)}
					{summaryText("Nombre de la idea", title || "No ingresado")}
					{summaryText("Descripción", description || "No ingresada")}
					{summaryText(
						"Categoría",
						selectedCategory?.name || "No seleccionada",
					)}
					{summaryText(
						"Área(s)",
						selectedAreas.length > 0
							? selectedAreas
									.map((area: SelectedOption) => area.name)
									.join(", ")
							: "No seleccionadas",
					)}
					{summaryText("Recursos necesarios", resources || "No ingresados")}
				</Box>

				<Button
					onClick={async () => {
						await onSave();
						onClose();
					}}
					endIcon={<SendHorizonal />}
				>
					Enviar idea
				</Button>
			</Box>
		</Modal>
	);
}
